module.exports = __webpack_public_path__ + "img/bonus_symbol_2.10e45481.png";